// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b54216f8","453":"1ae467b7"}[chunkId] + ".chunk.js";
};